import { render, staticRenderFns } from "./headerMain.vue?vue&type=template&id=2a011f3d&scoped=true&"
import script from "./headerMain.vue?vue&type=script&lang=js&"
export * from "./headerMain.vue?vue&type=script&lang=js&"
import style0 from "./headerMain.vue?vue&type=style&index=0&id=2a011f3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a011f3d",
  null
  
)

export default component.exports